'use client'

import React, { Fragment } from 'react'
import { Section } from '@/components/Section'
import { Heading } from '@/components/ui/heading'
import { Eyebrow } from '@/components/Eyebrow'
import { Text } from '@/components/ui/text'
import { TimelineBlock } from '@/payload-types'

export function TimelineClient({ heading, events }: TimelineBlock) {
  return (
    <Section bgClassName="bg-paper-2">
      <div className="flex flex-col lg:flex-row justify-between gap-20">
        <div className="lg:w-[400px]">
          <Heading size="h2">{heading}</Heading>
        </div>
        <div className="lg:w-[800px] flex flex-col">
          {events.map((item, index) => (
            <Fragment key={index}>
              <div className="flex flex-col lg:flex-row gap-[30px]">
                <Heading size="h2" className="w-[150px]">
                  {item.year}
                </Heading>
                <div className="w-[30px]">
                  <Eyebrow variant="dark" color="slime" className="mt-2" />
                </div>
                <Text className="flex-1">{item.description}</Text>
              </div>
              {index < events.length - 1 && <div className="w-full h-px bg-rock-3/50 my-[40px]" />}
            </Fragment>
          ))}
        </div>
      </div>
    </Section>
  )
}
